const MAX_HOLD_DURATION_HOURS = 168;

export const getHoldDurationValidationMessage = value => {
    if (value === null || value === undefined || value === '') {
        return "Enter a whole number between 1 and 168 hours.";
    }

    const hours = Number(value);
    if (!Number.isFinite(hours) || !Number.isInteger(hours)) {
        return "Enter a whole number between 1 and 168 hours.";
    }
    if (hours < 1) return "Enter at least 1 hour.";
    if (hours > MAX_HOLD_DURATION_HOURS) return "Enter no more than 168 hours (7 days).";
    return null;
};

const formatHoldDuration = hours => {
    const days = Math.floor(hours / 24);
    const remainingHours = hours % 24;
    const parts = [];

    if (days) parts.push(`${days} ${days === 1 ? 'day' : 'days'}`);
    if (remainingHours) parts.push(`${remainingHours} ${remainingHours === 1 ? 'hour' : 'hours'}`);

    return parts.join(' and ');
};

export const getHoldDurationDescription = values => {
    const value = values?.holdDurationHours;
    if (getHoldDurationValidationMessage(value)) {
        return "Choose a whole number from 1 to 168 hours (7 days). The customer's bank may release it sooner.";
    }

    return `Up to ${formatHoldDuration(Number(value))}. The customer's bank may release it sooner.`;
};
